export default __webpack_public_path__ + "static/15-899012b0bfe19ebfaec7999bd1baa152.png";